export default __webpack_public_path__ + "static/media/tap_here_top.1c8ec330.png";